/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-use-before-define */

import {
    AdditionalOptions, parseElementLogic,
} from './Questionnaire/helpers/logic'

import {
    NinchatEnvironmentConfig, NinchatQuestionnaireElement,
} from 'embed/types'

import QuestionnaireAttachment, {FileItem} from './Questionnaire/QuestionnaireAttachment'

import {
    QuestionnaireCheckbox, QuestionnaireCheckboxProps,
} from './Questionnaire/QuestionnaireCheckbox/QuestionnaireCheckbox'


import React, {
    useContext, useEffect, useLayoutEffect, useRef, useState,
} from 'react'
import {
    STEP_COMPONENT_DELAY,
    STEP_TEXT_DELAY, errorPage, errorText,
    errorWrapper,
    lightBotAnswerBubble,
    lightBotGroupLabel,
    navigationWrapper, questionnaireInnerWrapper, questionnaireWrapper, textBase,
    textLoader,
    textWrapper, viewContent, viewElementWrapper, viewWrapper,
} from './styles/questionnaire'

import {EmbedContext} from 'components/EmbedContext'
import {EmbedHero} from './components/EmbedHero/EmbedHero'
import {
    HeroExclamationTriangleIcon,
} from 'components/Icon'
import {NinchatProperties} from 'api/types'

import {QuestionnaireButton} from './Questionnaire/QuestionnaireButton/QuestionnaireButton'
import {QuestionnaireInput} from './Questionnaire/QuestionnaireInput/QuestionnaireInput'
import {QuestionnaireLightBot} from './Questionnaire/QuestionnaireLightBot/QuestionnaireLightBot'
import {QuestionnaireNavigation} from './Questionnaire/QuestionnaireNavigation/QuestionnaireNavigation'
import {QuestionnaireQueueButton} from './Questionnaire/QuestionnaireQueueButton/QuestionnaireQueueButton'
import {QuestionnaireRadio} from './Questionnaire/QuestionnaireRadio/QuestionnaireRadio'
import {QuestionnaireRating} from './Questionnaire/QuestionnaireRating/QuestionnaireRating'
import {QuestionnaireSSO} from './Questionnaire/QuestionnaireSSO/QuestionnaireSSO'
import {QuestionnaireSelect} from './Questionnaire/QuestionnaireSelect/QuestionnaireSelect'
import {QuestionnaireSwitch} from './Questionnaire/QuestionnaireSwitch/QuestionnaireSwitch'
import {QuestionnaireTextarea} from './Questionnaire/QuestionnaireTextarea/QuestionnaireTextarea'
import {QueueRoute} from 'embed/types/routes'

import ReactMarkdown from 'react-markdown'

// import {describeQueue} from 'api/action/describeQueue'
import {focusFirstElement} from 'embed/helpers'
import {markdownProps} from './helpers/markdown'
import {prepareMetadata} from './Questionnaire/helpers/metadata'
import {
    replaceVariables,
} from './Questionnaire/helpers'
import {styled} from 'stitches/config'
import {
    // useAppDispatch,
    useAppSelector,
} from './../../hooks'
import {useTranslation} from 'react-i18next'

export const coreName = 'questionnaire'

type FormElement = 'input' | 'textarea' | 'select' | 'checkbox' | 'radio' | 'switch' | 'rating' | 'sso' | 'attachment'

export type FormState = Record<string, {
    _isAudienceMetadata?: boolean
    value: string | boolean | number | FileItem[]
    readableName?: string
    groupName?: string
    type?: FormElement
    questionnaireType?: 'postAudienceQuestionnaire' | 'preAudienceQuestionnaire'
}>

export interface QuestionnaireParams {
  queueId: string
  userName?: string
  message?: string
  metadata: QueueRoute['params']['metadata']
  rating?: number
  fileIds?: Array<NinchatProperties.FileID>
}

interface QuestionnaireAnswerElement {
    name: string
    groupName: string
    text: string
    type?: FormElement
    updatedAt?: number
    value?: string | boolean | number | Array<string>
}

export interface QuestionnaireState {
    buttonInteraction?: boolean
    currentStep?: number
    messageSend?: boolean
    selectedQueueId?: string
    selectedMessage?: string
    selectedUsername?: string
    stepsHistory?: Array<number>
    formState?: FormState
    stepsAnswersHistory?: {
        [key: number]: any
        stepIndex?: Record<number, {
            [key: number]: any
            elemIndex?: Record<number, QuestionnaireAnswerElement>
        }>
    }
}

export interface EmbedQuestionnaireProps {
    onQuestionnaireComplete: (params: QuestionnaireParams) => Promise<{queueClosed?: boolean}>
    onQuestionnaireRegister?: (params: QuestionnaireParams) => Promise<any>
    saveQuestionnaireState: (state: QuestionnaireState) => void
    defaultQuestionnaireState: QuestionnaireState
    closeEmbed: (clearData?: boolean) => void
    resetEmbed: (clearData?: boolean) => void
    backToChat?: () => void
    type?: 'postAudienceQuestionnaire' | 'preAudienceQuestionnaire'
}

const StyledQuestionnaireWrapper = styled('div', questionnaireWrapper)
const StyledQuestionnaireInnerWrapper = styled('div', questionnaireInnerWrapper)

const StyledViewWrapper = styled('div', viewWrapper)

const StyledNavigationWrapper = styled('div', navigationWrapper)
const StyledViewContent = styled('div', viewContent)
const StyledViewElementWrapper = styled('div', viewElementWrapper)

const StyledTextBase = styled('div', textBase)
const StyledTextWrapper = styled('div', textWrapper)
const StyledTextLoader = styled('div', textLoader)

const StyledErrorWrapper = styled('div', errorWrapper)
const StyledErrorText = styled('div', errorText)
const StyledErrorPage = styled('div', errorPage)

const StyledLightBotAnswerBubble = styled('div', lightBotAnswerBubble)
const StyledLightBotGroupLabel = styled('div', lightBotGroupLabel)

export const EmbedQuestionnaire = (props: EmbedQuestionnaireProps) => {
    const {
        onQuestionnaireComplete, closeEmbed, backToChat, onQuestionnaireRegister,
        saveQuestionnaireState, defaultQuestionnaireState, type, resetEmbed,
    } = props
    const embed = useContext(EmbedContext)
    const {t} = useTranslation()
    const [questionnaireStarted, setQuestionnaireStarted] = useState(false)
    const [qreError, setQreError] = useState<{
        title: string
        message: string
    }| null>(null)

    const [selectedQueueId, setSelectedQueueId] = useState('')
    const [selectedQueueLength, setSelectedQueueLength] = useState(0)
    const [selectedQueueClosed, setSelectedQueueClosed] = useState(false)
    const [selectedQueueName, setSelectedQueueName] = useState('')

    const additionalOptions: AdditionalOptions = {
        queue_closed: selectedQueueClosed,
        queue_length: selectedQueueLength,
        queue_name: selectedQueueName,
    }

    const [selectedUsername, setSelectedUsername] = useState('')
    const [selectedMessage, setSelectedMessage] = useState('')
    const [selectedFiles, setSelectedFiles] = useState<Array<NinchatProperties.FileID>>([])

    const [currentStep, setCurrentStep] = useState<number | undefined>(0)
    const [stepsHistory, setStepsHistory] = useState<Array<number>>([])
    const [stepsAnswersHistory, setStepsAnswersHistory] = useState<QuestionnaireState['stepsAnswersHistory']>({})

    const [formState, setFormState] = useState<FormState>({})
    const [buttonInteraction, setButtonInteraction] = useState(false)
    const [formInteraction, setFormInteraction] = useState(false)


    const [validateStepRequiredFields, setValidateStepRequiredFields] = useState(false)
    const [validateCounter, setValidateCounter] = useState(0)
    const stepInvalidFields = useRef<Array<string>>([])

    const questionnaireWrapperRef = useRef<HTMLDivElement>(null)
    const questionnaireInnerWrapperRef = useRef<HTMLDivElement>(null)

    // const dispatch = useAppDispatch()

    const nextDelay = useRef(0)

    const audienceQueues = useAppSelector(({ninchat}) => {
        const realmQueues = ninchat._user_realm_queues
        return Object.keys(realmQueues).map((id) => ({
            ...realmQueues[id],
            queue_id: id,
        }))
    })
    const areAllQueuesClosed = (queueIds: Array<string>) => {
        if (queueIds.length === 0) {
            return true
        }

        const closedQueues = queueIds.filter((queueId) => {
            const queueDetails = audienceQueues.find((q) => q.queue_id === queueId)
            if (queueDetails?.queue_attrs.closed || queueDetails?.queue_attrs.suspended) {
                return true
            }
            return false
        })

        // all queues are closed
        if (queueIds.length === closedQueues.length) {
            return true
        }

        return false
    }

    const questionnaireUserValues = embed?.questionnaireValues || {} // values set by user
    const questionnairePredefinedValues = {queueName: ''} // predefined values that can be used by user

    const questionnaireValues = {
        ...questionnairePredefinedValues,
        ...questionnaireUserValues,
    }

    const questionnaire = type ? (embed || {})[type] || [] : []


    const handleTextComponentClick = (event: React.MouseEvent) => {
        if (event.target instanceof HTMLImageElement) {
            // open(event.target.src, null, {
            //     downloadDisabled: true,
            // })
        }
    }

    // eslint-disable-next-line max-params
    const handleChangeFormState = ({
        name, value, readableName, groupName, type: controlType,
    }: {name: string, value: string | boolean | FileItem[], readableName?: string, groupName?: string, invalid?: boolean, type?: FormState[string]['type']}) => {
        setFormState((curState) => ({
            ...curState,
            [name]: {
                groupName,
                questionnaireType: type,
                readableName,
                type: controlType,
                value,
            },
        }))
    }

    const handleSetInvalidFields = (name: string, invalid: boolean) => {
        if (invalid && !stepInvalidFields.current.includes(name)) {
            stepInvalidFields.current.push(name)
        } else if (!invalid) {
            stepInvalidFields.current = stepInvalidFields.current.filter((fieldName) => fieldName !== name)
        }
    }

    const updateAnswersHistory = (stepIndex?: number, elementIndex?: number, data?: any) => {
        setTimeout(() => {
            setStepsAnswersHistory((sah) => ({
                ...sah,
                [stepIndex || 0]: {
                    ...sah?.[stepIndex || 0],
                    [elementIndex || 0]: data,
                },
            }))
        }, 0)
    }

    // eslint-disable-next-line max-params
    const parseElement = (el: NinchatQuestionnaireElement, hideFormElements?: boolean, stepIndex?: number, elementIndex?: number) => {
        let delay = nextDelay.current

        if (elementIndex === undefined) {
            nextDelay.current += 0
        } else if (el.element === 'text') {
            nextDelay.current += STEP_TEXT_DELAY
        } else if (el.element === 'error') {
            nextDelay.current += 0
        } else {
            nextDelay.current += STEP_COMPONENT_DELAY
        }

        switch (el.element) {
            case 'text': {
                const {
                    text, align, hide: defaultHide, logic, color, background, borderRadius, padding, margin, fontSize, ...defaultAttributes
                } = el

                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet && logic) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_TEXT_DELAY
                    nextDelay.current -= STEP_TEXT_DELAY
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                return (
                    <StyledViewElementWrapper
                        css={{
                            $$delay: `${delay}s`,
                            margin,
                        }}
                        currentElement={!hideFormElements}
                        hide={hide}
                        isText={true}
                        lightBot={embed?.lightBot}
                    >
                        <StyledTextBase lightBot={embed?.lightBot}>
                            <StyledTextWrapper
                                align={align}
                                css={{
                                    $$background: background,
                                    $$borderRadius: borderRadius,
                                    $$color: color,
                                    $$delay: `${delay}s`,
                                    $$fontSize: fontSize,
                                    $$padding: padding,
                                }}
                                currentElement={!hideFormElements}
                                lightBot={embed?.lightBot}
                                onClick={handleTextComponentClick}
                                {...({
                                    ...defaultAttributes,
                                    ...attributes,
                                    element: undefined,
                                })}
                            >
                                <ReactMarkdown {...markdownProps}>
                                    {replaceVariables(text || '', questionnaireValues, formState, additionalOptions)}
                                </ReactMarkdown>
                            </StyledTextWrapper>
                            {!hideFormElements && embed?.lightBot ? <StyledTextLoader css={{$$delay: `${delay}s`}} /> : null}
                        </StyledTextBase>
                    </StyledViewElementWrapper>
                )
            }
            case 'error': {
                const {
                    text, logic, variant, name, margin, padding, ...defaultAttributes
                } = el

                const {
                    attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                let hide = true
                if (validateStepRequiredFields) {
                    hide = false
                }
                if (conditionMet && logic) {
                    hide = true
                }

                if (embed?.lightBot && hideFormElements) {
                    return null
                }

                handleSetInvalidFields(name, !hide)

                return (
                    <StyledViewElementWrapper
                        css={{
                            $$delay: `${delay}s`,
                            margin,
                        }}
                        currentElement={!hideFormElements}
                        hide={hide}
                        isText={false}
                        lightBot={embed?.lightBot}
                    >
                        <StyledTextBase>
                            <StyledErrorWrapper
                                aria-hidden={hide ? 'true' : 'false'}
                                {...({
                                    ...defaultAttributes,
                                    ...attributes,
                                    element: undefined,
                                })}
                                css={{padding}}
                                variant={variant}
                            >
                                {variant !== 'group' && <HeroExclamationTriangleIcon />}
                                <StyledErrorText variant={variant}>
                                    <ReactMarkdown {...markdownProps}>
                                        {replaceVariables(text || '', questionnaireValues, formState, additionalOptions)}
                                    </ReactMarkdown>
                                </StyledErrorText>
                            </StyledErrorWrapper>
                        </StyledTextBase>
                    </StyledViewElementWrapper>
                )
            }
            case 'button': {
                const {
                    align, text, target, variant, inline, textAlign, maxWidth, margin, padding, title,
                    validateRequired, iconLeft, iconRight, href, hide: defaultHide, logic, ...defaultAttributes
                } = el


                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet && logic) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_COMPONENT_DELAY
                    nextDelay.current -= STEP_COMPONENT_DELAY
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                if (embed?.lightBot && hideFormElements) {
                    return null
                }

                return (
                    <QuestionnaireButton
                        align={align}
                        currentElement={!hideFormElements}
                        delay={delay}
                        hide={hide}
                        href={replaceVariables(href || '', questionnaireValues, formState, additionalOptions)}
                        iconLeft={iconLeft}
                        iconRight={iconRight}
                        inline={inline}
                        lightBot={embed?.lightBot}
                        margin={margin}
                        maxWidth={maxWidth}
                        onClick={() => {
                            setButtonInteraction(true)

                            if (validateRequired && !validateStepRequiredFields) {
                                // this triggeres all step field to validate itself
                                setValidateStepRequiredFields(true)
                                setValidateCounter((cur) => cur + 1)

                                // to handle situation if after refresh we are validating for the first time
                                setTimeout(() => {
                                    if (stepInvalidFields.current.length === 0) {
                                        setValidateStepRequiredFields(false)
                                        setValidateCounter(0)
                                        handleFindStep(target || '')
                                    }
                                }, 0)
                            } else if (validateRequired && stepInvalidFields.current.length === 0) {
                                setValidateStepRequiredFields(false)
                                setValidateCounter(0)
                                handleFindStep(target || '')
                            // eslint-disable-next-line no-negated-condition
                            } else if (!validateRequired) {
                                setValidateStepRequiredFields(false)
                                setValidateCounter(0)
                                handleFindStep(target || '')
                            } else if (validateRequired) {
                                setValidateCounter((cur) => cur + 1)
                            }
                        }}
                        padding={padding}
                        target={target}
                        text={replaceVariables(text || '', questionnaireValues, formState, additionalOptions)}
                        textAlign={textAlign}
                        title={replaceVariables(title || '', questionnaireValues, formState, additionalOptions)}
                        variant={variant}
                        {...({
                            ...defaultAttributes,
                            ...attributes,
                            element: undefined,
                        })}
                    />
                )
            }
            case 'queue_button': {
                const {
                    align, textAlign, inline, text, target, padding,
                    text_closed, queue_id, hide: defaultHide, logic, margin, ...defaultAttributes
                } = el


                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet && logic) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_COMPONENT_DELAY
                    nextDelay.current -= STEP_COMPONENT_DELAY
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                const getQueueName = (queueId: string) => {
                    const queue = audienceQueues.find((q) => q.queue_id === queueId)
                    return queue?.queue_attrs.name
                }

                const values = {
                    ...questionnaireValues,
                    queue_name: getQueueName(queue_id || '') || '',
                }


                if (embed?.lightBot && hideFormElements) {
                    const answer = stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0]

                    if (answer?.text) {
                        return (
                            <StyledLightBotAnswerBubble>
                                <div>{answer.text}</div>
                            </StyledLightBotAnswerBubble>)
                    }
                    return null
                }

                return (
                    <StyledViewElementWrapper
                        css={{
                            $$delay: `${delay}s`,
                            margin,
                        }}
                        currentElement={!hideFormElements}
                        hide={hide}
                        isComponent={true}
                        lightBot={embed?.lightBot}
                    >
                        <QuestionnaireQueueButton
                            align={align}
                            formState={formState}
                            inline={inline}
                            onClick={(queueId, tar) => {
                                updateAnswersHistory(stepIndex, elementIndex, {text: replaceVariables(text || '', values, formState, additionalOptions)})
                                handleQuestionnaireQueueButtonClick(queueId, tar)
                            }}
                            padding={padding}
                            questionnaireValues={questionnaireValues}
                            queue_id={queue_id || ''}
                            target={target || '_next'}
                            text={text}
                            textAlign={textAlign}
                            text_closed={text_closed}
                            {...({
                                ...defaultAttributes,
                                ...attributes,
                                element: undefined,

                            })}
                        />
                    </StyledViewElementWrapper>
                )
            }
            case 'textarea': {
                const {
                    label, placeholder, id, rows, resizable, margin, padding,
                    required, labelDescription, name, hide: defaultHide,
                    logic, readableName, groupName, ...defaultAttributes
                } = el

                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet && logic) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_COMPONENT_DELAY
                    nextDelay.current -= STEP_COMPONENT_DELAY
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                if (embed?.lightBot && hideFormElements) {
                    const answer = stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0]

                    if (answer?.text) {
                        return (
                            <StyledLightBotAnswerBubble>
                                <div>
                                    <StyledLightBotGroupLabel>{readableName || label}</StyledLightBotGroupLabel>
                                    <div>{answer.text}</div>
                                </div>
                            </StyledLightBotAnswerBubble>
                        )
                    }
                    return null
                }

                // if we are opening same step for the second time, we need to make sure that answer history is updated
                if (embed?.lightBot && stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0] === undefined) {
                    updateAnswersHistory(
                        stepIndex,
                        elementIndex,
                        {text: `${formState[`${coreName}-${name}`]?.value ? formState[`${coreName}-${name}`].value.toString() : ''}`},
                    )
                }

                //  handle situation when in post audience questionnaire we are showing the same fields as in pre audience questionnaire
                if (formState[`${coreName}-${name}`]?.questionnaireType === 'preAudienceQuestionnaire' && type === 'postAudienceQuestionnaire') {
                    handleChangeFormState({
                        ...formState[`${coreName}-${name}`],
                        name: `${coreName}-${name}`,
                    } as any)
                }

                return (
                    <StyledViewElementWrapper
                        css={{
                            $$delay: `${delay}s`,
                            margin,
                        }}
                        currentElement={!hideFormElements}
                        hide={hide}
                        isComponent={true}
                        lightBot={embed?.lightBot}
                    >
                        <QuestionnaireTextarea
                            forceValidation={validateStepRequiredFields}
                            groupName={groupName}
                            id={`${coreName}-${id}`}
                            label={replaceVariables(label || '', questionnaireValues, formState)}
                            labelDescription={required ? t('Required') : replaceVariables(labelDescription || '', questionnaireValues, formState, additionalOptions)}
                            name={`${coreName}-${name}`}
                            onChange={(data) => {
                                if (data.value) {
                                    updateAnswersHistory(stepIndex, elementIndex, {text: `${data.value ? data.value.toString() : ''}`})
                                }
                                handleChangeFormState(data)
                                setFormInteraction(true)
                            }}
                            padding={padding}
                            placeholder={replaceVariables(placeholder || '', questionnaireValues, formState, additionalOptions)}
                            readableName={readableName}
                            required={required}
                            resizable={resizable}
                            rows={rows || 3}
                            setInvalidFields={handleSetInvalidFields}
                            value={formState[`${coreName}-${name}`]?.value ? formState[`${coreName}-${name}`].value.toString() : ''}
                            {...({
                                ...defaultAttributes,
                                ...attributes,
                                element: undefined,
                            })}
                        />
                    </StyledViewElementWrapper>
                )
            }
            case 'input': {
                const {
                    label, placeholder, id, required, labelDescription, name, margin, invalidText, padding,
                    hide: defaultHide, logic, readableName, groupName, ...defaultAttributes
                } = el

                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet && logic) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_COMPONENT_DELAY
                    nextDelay.current -= STEP_COMPONENT_DELAY
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                if (embed?.lightBot && hideFormElements) {
                    const answer = stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0]

                    if (answer?.text) {
                        return (
                            <StyledLightBotAnswerBubble>
                                <div>
                                    <StyledLightBotGroupLabel>{readableName || label}</StyledLightBotGroupLabel>
                                    <div>{answer.text}</div>
                                </div>
                            </StyledLightBotAnswerBubble>
                        )
                    }
                    return null
                }

                // if we are opening same step for the second time, we need to make sure that answer history is updated
                if (embed?.lightBot && stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0] === undefined) {
                    updateAnswersHistory(
                        stepIndex,
                        elementIndex,
                        {text: `${formState[`${coreName}-${name}`]?.value ? formState[`${coreName}-${name}`].value.toString() : ''}`},
                    )
                }

                //  handle situation when in post audience questionnaire we are showing the same fields as in pre audience questionnaire
                if (formState[`${coreName}-${name}`]?.questionnaireType === 'preAudienceQuestionnaire' && type === 'postAudienceQuestionnaire') {
                    handleChangeFormState({
                        ...formState[`${coreName}-${name}`],
                        name: `${coreName}-${name}`,
                    } as any)
                }

                return (
                    <StyledViewElementWrapper
                        css={{
                            $$delay: `${delay}s`,
                            margin,
                        }}
                        currentElement={!hideFormElements}
                        hide={hide}
                        isComponent={true}
                        lightBot={embed?.lightBot}
                    >
                        <QuestionnaireInput
                            forceValidation={validateStepRequiredFields}
                            groupName={groupName}
                            id={`${coreName}-${id}`}
                            invalidText={replaceVariables(invalidText || '', questionnaireValues, formState, additionalOptions)}
                            label={replaceVariables(label || '', questionnaireValues, formState, additionalOptions)}
                            labelDescription={required ? t('Required') : replaceVariables(labelDescription || '', questionnaireValues, formState, additionalOptions)}
                            name={`${coreName}-${name}`}
                            onChange={(data) => {
                                if (data.value) {
                                    updateAnswersHistory(stepIndex, elementIndex, {text: `${data.value ? data.value.toString() : ''}`})
                                }
                                handleChangeFormState(data)
                                setFormInteraction(true)
                            }}
                            padding={padding}
                            placeholder={replaceVariables(placeholder || '', questionnaireValues, formState, additionalOptions)}
                            readableName={readableName}
                            required={required}
                            setInvalidFields={handleSetInvalidFields}
                            value={formState[`${coreName}-${name}`]?.value ? formState[`${coreName}-${name}`].value.toString() : ''}
                            {...({
                                ...defaultAttributes,
                                ...attributes,
                                element: undefined,
                            })}
                        />
                    </StyledViewElementWrapper>
                )
            }
            case 'select': {
                const {
                    label, placeholder, id, labelDescription, required, margin, invalidText, padding,
                    name, hide: defaultHide, logic, readableName, groupName, items, ...defaultAttributes
                } = el

                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet && logic) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_COMPONENT_DELAY
                    nextDelay.current -= STEP_COMPONENT_DELAY
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                if (embed?.lightBot &&
                    stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0] === undefined) {
                    updateAnswersHistory(
                        stepIndex,
                        elementIndex,
                        {
                            groupName,
                            name,
                            text: items.find((i) => i.value === formState[`${coreName}-${name}`]?.value)?.text || '',
                        },
                    )
                }

                if (embed?.lightBot && hideFormElements) {
                    const answer = stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0]

                    if (answer?.text) {
                        return (
                            <StyledLightBotAnswerBubble>
                                <div>
                                    <StyledLightBotGroupLabel>{readableName || label}</StyledLightBotGroupLabel>
                                    <div>{answer.text}</div>
                                </div>
                            </StyledLightBotAnswerBubble>)
                    }
                    return null
                }

                //  handle situation when in post audience questionnaire we are showing the same fields as in pre audience questionnaire
                if (formState[`${coreName}-${name}`]?.questionnaireType === 'preAudienceQuestionnaire' && type === 'postAudienceQuestionnaire') {
                    handleChangeFormState({
                        ...formState[`${coreName}-${name}`],
                        name: `${coreName}-${name}`,
                    } as any)
                }

                return (
                    <StyledViewElementWrapper
                        css={{
                            $$delay: `${delay}s`,
                            margin,
                        }}
                        currentElement={!hideFormElements}
                        hide={hide}
                        isComponent={true}
                        lightBot={embed?.lightBot}
                    >
                        <QuestionnaireSelect
                            forceValidation={validateStepRequiredFields}
                            groupName={groupName}
                            id={`${coreName}-${id}`}
                            invalidText={replaceVariables(invalidText || '', questionnaireValues, formState, additionalOptions)}
                            items={items || []}
                            label={replaceVariables(label || '', questionnaireValues, formState, additionalOptions)}
                            labelDescription={required ? t('Required') : replaceVariables(labelDescription || '', questionnaireValues, formState, additionalOptions)}
                            name={`${coreName}-${name}`}
                            onChange={(data) => {
                                updateAnswersHistory(stepIndex, elementIndex, {text: data.text})
                                handleChangeFormState(data)
                                setFormInteraction(true)
                            }}
                            padding={padding}
                            placeholder={replaceVariables(placeholder || '', questionnaireValues, formState, additionalOptions)}
                            readableName={readableName}
                            required={required}
                            setInvalidFields={handleSetInvalidFields}
                            value={formState[`${coreName}-${name}`]?.value ? formState[`${coreName}-${name}`].value.toString() : ''}
                            {...({
                                ...defaultAttributes,
                                ...attributes,
                                element: undefined,

                            })}
                        />
                    </StyledViewElementWrapper>
                )
            }
            case 'checkbox': {
                const {
                    id, text, description, name, hide: defaultHide, logic, errorId,
                    readableName, groupName, selected, margin, ...defaultAttributes
                } = el

                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet && logic) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_COMPONENT_DELAY
                    nextDelay.current -= STEP_COMPONENT_DELAY
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                // if we are opening same step for the second time, we need to make sure that answer history is updated
                if (embed?.lightBot && stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0] === undefined) {
                    updateAnswersHistory(
                        stepIndex,
                        elementIndex,
                        {
                            groupName,
                            name,
                            text: `${formState[`${coreName}-${name}`]?.value ? replaceVariables(text || '', questionnaireValues, formState, additionalOptions) : ''}`,
                            type: 'checkbox',
                        },
                    )
                }

                if (embed?.lightBot && hideFormElements) {
                    const answer = stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0]

                    // standalone checkbox without group
                    if (!answer?.groupName && answer?.text) {
                        return <StyledLightBotAnswerBubble><div>{answer.text}</div></StyledLightBotAnswerBubble>
                    }

                    const groupCheckboxes =
                    // eslint-disable-next-line no-extra-parens
                         (Object.values(stepsAnswersHistory?.[stepIndex || 0]) as Array<QuestionnaireAnswerElement>)
                             .filter((v) => groupName && v.groupName === groupName && v.type === 'checkbox')


                    const groupCheckboxesWithValues = groupCheckboxes.filter((v) => v.text)
                    // all checkboxes from the same group need to be displayed together at once
                    if (groupCheckboxesWithValues.length > 0 && groupCheckboxesWithValues[0]?.name === name) {
                        return (
                            <StyledLightBotAnswerBubble>
                                <div>
                                    <StyledLightBotGroupLabel>{groupName}</StyledLightBotGroupLabel>
                                    <div>{ groupCheckboxesWithValues.map((cb) => cb.text).join(', ') }</div>
                                </div>
                            </StyledLightBotAnswerBubble>
                        )
                    } else if (groupName && groupCheckboxesWithValues.length === 0 && groupCheckboxes[0]?.name === name) {
                        return (
                            <StyledLightBotAnswerBubble>
                                <div>
                                    <StyledLightBotGroupLabel>{groupName}</StyledLightBotGroupLabel>
                                    <div>{t('None')}</div>
                                </div>
                            </StyledLightBotAnswerBubble>
                        )
                    }
                    return null
                }

                //  handle situation when in post audience questionnaire we are showing the same fields as in pre audience questionnaire
                if (formState[`${coreName}-${name}`]?.questionnaireType === 'preAudienceQuestionnaire' && type === 'postAudienceQuestionnaire') {
                    handleChangeFormState({
                        ...formState[`${coreName}-${name}`],
                        name: `${coreName}-${name}`,
                    } as any)
                }

                return (
                    <StyledViewElementWrapper
                        css={{
                            $$delay: `${delay}s`,
                            margin,
                        }}
                        currentElement={!hideFormElements}
                        hide={hide}
                        isComponent={true}
                        lightBot={embed?.lightBot}
                    >
                        <QuestionnaireCheckbox
                            description={replaceVariables(description || '', questionnaireValues, formState, additionalOptions)}
                            errorId={errorId}
                            groupName={groupName}
                            id={`${coreName}-${id}`}
                            name={`${coreName}-${name}`}
                            onChange={(values: Parameters<QuestionnaireCheckboxProps['onChange']>[0], isInitial?: boolean) => {
                                updateAnswersHistory(stepIndex, elementIndex, {
                                    groupName,
                                    name,
                                    text: `${values.value ? replaceVariables(text || '', questionnaireValues, formState, additionalOptions) : ''}`,
                                    type: 'checkbox',
                                })
                                handleChangeFormState({
                                    ...values,
                                    type: 'checkbox',
                                })

                                if (!isInitial) {
                                    setFormInteraction(true)
                                }
                            }}
                            readableName={readableName}
                            text={replaceVariables(text || '', questionnaireValues, formState, additionalOptions)}
                            value={typeof formState[`${coreName}-${name}`]?.value === 'undefined' && selected ? selected : !!formState[`${coreName}-${name}`]?.value}
                            {...({
                                ...defaultAttributes,
                                ...attributes,
                                element: undefined,
                            })}
                        />
                    </StyledViewElementWrapper>
                )
            }
            case 'switch': {
                const {
                    id, text, name, hide: defaultHide, logic, readableName,
                    groupName, selected, margin, ...defaultAttributes
                } = el

                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_COMPONENT_DELAY
                    nextDelay.current -= STEP_COMPONENT_DELAY
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                if (embed?.lightBot && stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0] === undefined) {
                    updateAnswersHistory(
                        stepIndex,
                        elementIndex,
                        {text: `${formState[`${coreName}-${name}`]?.value ? replaceVariables(text || '', questionnaireValues, formState, additionalOptions) : ''}`},
                    )
                }

                if (embed?.lightBot && hideFormElements) {
                    const answer = stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0]

                    if (answer?.text) {
                        return (
                            <StyledLightBotAnswerBubble>
                                <div>
                                    <div>{answer.text}</div>
                                </div>
                            </StyledLightBotAnswerBubble>)
                    }
                    return null
                }

                //  handle situation when in post audience questionnaire we are showing the same fields as in pre audience questionnaire
                if (formState[`${coreName}-${name}`]?.questionnaireType === 'preAudienceQuestionnaire' && type === 'postAudienceQuestionnaire') {
                    handleChangeFormState({
                        ...formState[`${coreName}-${name}`],
                        name: `${coreName}-${name}`,
                    } as any)
                }

                return (
                    <StyledViewElementWrapper
                        css={{
                            $$delay: `${delay}s`,
                            margin,
                        }}
                        currentElement={!hideFormElements}
                        hide={hide}
                        isComponent={true}
                        lightBot={embed?.lightBot}
                    >
                        <QuestionnaireSwitch
                            groupName={groupName}
                            id={`${coreName}-${id}`}
                            name={`${coreName}-${name}`}
                            onChange={(data) => {
                                updateAnswersHistory(stepIndex, elementIndex, {text: `${data.value ? replaceVariables(text || '', questionnaireValues, formState, additionalOptions) : ''}`})
                                handleChangeFormState(data)
                                setFormInteraction(true)
                            }}
                            readableName={readableName}
                            text={replaceVariables(text || '', questionnaireValues, formState, additionalOptions)}
                            value={typeof formState[`${coreName}-${name}`]?.value === 'undefined' && selected ? selected : !!formState[`${coreName}-${name}`]?.value}
                            {...({
                                ...defaultAttributes,
                                ...attributes,
                                element: undefined,
                            })}
                        />
                    </StyledViewElementWrapper>
                )
            }
            case 'radio': {
                const {
                    text, id, name, value, inline, hide: defaultHide, logic, readableName, errorId,
                    groupName, target, align, textAlign, iconLeft, iconRight,
                    margin, maxWidth, padding, ...defaultAttributes
                } = el

                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet && logic) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_COMPONENT_DELAY
                    nextDelay.current -= STEP_COMPONENT_DELAY
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                if (embed?.lightBot && stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0] === undefined && !target) {
                    // all group radios from the same step and the same group, sorted by updatedAt desc
                    updateAnswersHistory(
                        stepIndex,
                        elementIndex,
                        {
                            groupName,
                            name,
                            text: formState[`${coreName}-${name}`]?.value === value ? `${replaceVariables(text || '', questionnaireValues, formState, additionalOptions)}` : '',
                            type: 'radio',
                            updatedAt: formState[`${coreName}-${name}`]?.value === value ? Date.now() : 0,
                            value,
                        },
                    )
                }

                if (embed?.lightBot && hideFormElements) {
                    // all group radios from the same step, sorted by updatedAt desc
                    const groupRadios =
                    // eslint-disable-next-line no-extra-parens
                         (Object.values(stepsAnswersHistory?.[stepIndex || 0] || {}) as Array<QuestionnaireAnswerElement>)
                             .filter((v) => groupName && (v.groupName === groupName || v.name === name) && v.type === 'radio' && v.text)
                             .sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))


                    if (groupRadios[0]?.text && groupRadios[0]?.value === value) {
                        return (
                            <StyledLightBotAnswerBubble>
                                <div>
                                    <StyledLightBotGroupLabel>{groupName}</StyledLightBotGroupLabel>
                                    <div>{groupRadios[0].text}</div>
                                </div>
                            </StyledLightBotAnswerBubble>
                        )
                    }
                    return null
                }

                //  handle situation when in post audience questionnaire we are showing the same fields as in pre audience questionnaire
                if (formState[`${coreName}-${name}`]?.questionnaireType === 'preAudienceQuestionnaire' && type === 'postAudienceQuestionnaire') {
                    handleChangeFormState({
                        ...formState[`${coreName}-${name}`],
                        name: `${coreName}-${name}`,
                    } as any)
                }

                return (
                    <QuestionnaireRadio
                        align={align}
                        checked={formState[`${coreName}-${name}`]?.value === value}
                        currentElement={!hideFormElements}
                        delay={delay}
                        errorId={errorId}
                        groupName={groupName}
                        hide={hide}
                        iconLeft={iconLeft}
                        iconRight={iconRight}
                        id={`${coreName}-${id}`}
                        inline={inline}
                        lightBot={embed?.lightBot}
                        margin={margin}
                        maxWidth={maxWidth}
                        name={`${coreName}-${name}`}
                        onChange={(data) => {
                            if (!target) {
                                updateAnswersHistory(stepIndex, elementIndex, {
                                    groupName,
                                    name,
                                    text: `${replaceVariables(text || '', questionnaireValues, formState, additionalOptions)}`,
                                    type: 'radio',
                                    updatedAt: Date.now(),
                                    value,
                                })
                            }

                            handleChangeFormState(data)
                            setFormInteraction(true)
                        }}
                        onClick={() => {
                            if (target) {
                                updateAnswersHistory(stepIndex, elementIndex, {
                                    groupName,
                                    name,
                                    text: `${replaceVariables(text || '', questionnaireValues, formState, additionalOptions)}`,
                                    type: 'radio',
                                    updatedAt: Date.now(),
                                    value,
                                })
                                // to make sure redirect will happen after radio state has changed
                                setTimeout(() => {
                                    handleFindStep(target || '')
                                }, 0)
                            }
                        }}
                        padding={padding}
                        readableName={readableName}
                        text={replaceVariables(text || '', questionnaireValues, formState, additionalOptions)}
                        textAlign={textAlign}
                        value={value}
                        {...({
                            ...defaultAttributes,
                            ...attributes,
                            element: undefined,
                        })}
                    />
                )
            }
            case 'sso': {
                const {
                    hide: defaultHide, logic, margin, showDelegateAuthentication, showAuthentication,
                    accessType, accessUrl, ssoName,
                    ...defaultAttributes
                } = el

                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet && logic) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_COMPONENT_DELAY
                    nextDelay.current -= STEP_COMPONENT_DELAY
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                return (
                    <StyledViewElementWrapper
                        css={{
                            $$delay: `${nextDelay.current}s`,
                            margin,
                        }}
                        currentElement={!hideFormElements}
                        hide={hide}
                        isComponent={true}
                        lightBot={embed?.lightBot}
                    >
                        <QuestionnaireSSO
                            accessType={accessType || ''}
                            accessUrl={accessUrl || embed?.parentUrl}
                            handleError={(error: string) => {
                                // eslint-disable-next-line no-console
                                console.log(error)
                            }}
                            handleSuccess={() => {
                                handleFindStep('_next')
                            }}
                            hideButton={hideFormElements}
                            showAuthentication={showAuthentication === undefined ? true : showAuthentication}
                            showDelegateAuthentication={showDelegateAuthentication === undefined ? false : showDelegateAuthentication}
                            ssoName={ssoName || ''}
                            {...({
                                ...defaultAttributes,
                                ...attributes,
                                element: undefined,
                            })}
                        />
                    </StyledViewElementWrapper>
                )
            }
            case 'rating': {
                const {
                    name, hide: defaultHide, logic, margin,
                    readableName, groupName, type: ratingType,
                    npsDetails, reverse, icons, align, target, ...defaultAttributes
                } = el

                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet && logic) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_COMPONENT_DELAY
                    nextDelay.current -= STEP_COMPONENT_DELAY
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                if (embed?.lightBot && hideFormElements) {
                    const answer = stepsAnswersHistory?.[stepIndex || 0]?.[elementIndex || 0]

                    if (answer?.value) {
                        return (
                            <StyledLightBotAnswerBubble>
                                <div>
                                    {ratingType === 'nps' ? <StyledLightBotGroupLabel>NPS</StyledLightBotGroupLabel> : null}
                                    <div>
                                        <QuestionnaireRating
                                            icons={icons}
                                            lightBotAnswer={answer.value}
                                            name={`${coreName}-${name}`}
                                            onChange={() => null}
                                            onSendRating={() => null}
                                            target={target || ''}
                                            type={ratingType}
                                        />
                                    </div>
                                </div>
                            </StyledLightBotAnswerBubble>
                        )
                    }
                    return null
                }

                return (
                    <StyledViewElementWrapper
                        css={{
                            $$delay: `${delay}s`,
                            margin,
                        }}
                        currentElement={!hideFormElements}
                        hide={hide}
                        isComponent={true}
                        lightBot={embed?.lightBot}
                    >
                        <QuestionnaireRating
                            align={align}
                            groupName={groupName}
                            icons={icons}
                            name={`${coreName}-${name}`}
                            npsDetails={npsDetails}
                            onChange={(data) => {
                                updateAnswersHistory(stepIndex, elementIndex, {value: `${data.value ? data.value : ''}`})
                                handleChangeFormState(data)
                            }}
                            onSendRating={(targ: string) => {
                                handleFindStep(targ || '_next')
                            }}
                            readableName={readableName}
                            reverse={reverse}
                            target={target}
                            type={ratingType}
                            {...({
                                ...defaultAttributes,
                                ...attributes,
                                element: undefined,
                            })}
                        />
                    </StyledViewElementWrapper>
                )
            }
            case 'attachment': {
                const {
                    hide: defaultHide, logic, margin, name, ...defaultAttributes
                } = el

                let hide = defaultHide

                const {
                    hide: logicHide, attributes, conditionMet,
                } = parseElementLogic(logic, formState, additionalOptions)

                if (conditionMet && logic) {
                    hide = logicHide
                }

                if (hide) {
                    delay -= STEP_COMPONENT_DELAY
                    nextDelay.current -= delay
                } else if (defaultHide && formInteraction) {
                    delay = 0
                }

                const initialFiles = formState[`${coreName}-${name}`]?.value || []

                if (embed?.lightBot && hideFormElements) {
                    return (
                        <QuestionnaireAttachment
                            files={initialFiles}
                            hideActions={hideFormElements}
                            onChange={() => null}
                            onContinue={() => null}
                            {...({
                                ...defaultAttributes,
                                ...attributes,
                                element: undefined,
                            })}
                        />
                    )
                }

                return (
                    <StyledViewElementWrapper
                        css={{
                            $$delay: `${delay}s`,
                            margin,
                        }}
                        currentElement={!hideFormElements}
                        hide={hide}
                        isComponent={true}
                        lightBot={embed?.lightBot}
                    >
                        <QuestionnaireAttachment
                            files={initialFiles}
                            onChange={(files) => {
                                // updateAnswersHistory(stepIndex, elementIndex, {value: `${data.value ? data.value : ''}`})
                                handleChangeFormState({
                                    name: `${coreName}-${name}`,
                                    type: 'attachment',
                                    value: files,
                                })

                                const filesToAdd = files.reduce((acc, file) => {
                                    if (file.file_id) {
                                        acc.push(file.file_id)
                                    }
                                    return acc
                                }, [] as Array<NinchatProperties.FileID>)

                                setSelectedFiles([...filesToAdd])
                            }}
                            onContinue={() => handleFindStep('_next')}
                            {...({
                                ...defaultAttributes,
                                ...attributes,
                                element: undefined,
                            })}
                        />
                    </StyledViewElementWrapper>
                )
            }
            default:
                return null
        }
    }

    const parseQuestionnaireStep = (step: NinchatEnvironmentConfig['preAudienceQuestionnaire'][0], hideFormElements?: boolean, stepIndex?: number) => {
        switch (step?.type) {
            case 'view': {
                const {
                    elements, navigation: stepNav,
                } = step

                const {
                    elements: navElements, position, fixed, enableMobileStacking,
                } = stepNav || {}


                nextDelay.current = 0
                // eslint-disable-next-line react/no-array-index-key, max-len
                const elementsToRender = elements?.map((element: NinchatQuestionnaireElement, key: number) => {
                    const rendered = parseElement(element, hideFormElements, stepIndex, key)
                    // eslint-disable-next-line react/no-array-index-key
                    return rendered === null ? null : <React.Fragment key={key}>{rendered}</React.Fragment>
                }).filter((el) => el !== null)

                const hideStep = embed?.lightBot && elementsToRender?.length === 0

                if (hideStep) {
                    return null
                }

                return (
                    <StyledViewWrapper key={currentStep}>
                        {navElements && position === 'top' && !hideFormElements && !embed?.lightBot ?
                            <StyledNavigationWrapper fixed={fixed} position='top'>
                                <QuestionnaireNavigation elements={navElements} enableMobileStacking={enableMobileStacking} parseElement={parseElement} position='top' />
                            </StyledNavigationWrapper>
                            : null}
                        <StyledViewContent>
                            {elementsToRender}
                        </StyledViewContent>
                        {navElements && position !== 'top' && !hideFormElements && !embed?.lightBot ?
                            <StyledNavigationWrapper fixed={fixed} position='bottom'>
                                <QuestionnaireNavigation elements={navElements} enableMobileStacking={enableMobileStacking} parseElement={parseElement} position='bottom' />
                            </StyledNavigationWrapper>
                            : null}
                    </StyledViewWrapper>
                )
            }
            case 'logic-queues-closed': {
                const {
                    result: {
                        target_success, target_fail,
                    },
                } = step
                const queuesToCheck = step.queues || []
                const allClosed = areAllQueuesClosed(queuesToCheck)

                setTimeout(() => {
                    if (allClosed) {
                        handleFindStep(target_success || '_next')
                    } else {
                        handleFindStep(target_fail || '_next')
                    }
                }, 0)
                return null
            }
            case 'logic': {
                const {
                    conditions, result: {
                        target_success, target_fail, queueId, message, userName,
                    },
                } = step

                const {conditionMet} = parseElementLogic({
                    conditions,
                    result: {},
                }, formState, additionalOptions)

                setTimeout(() => {
                    if (conditionMet) {
                        if (queueId) {
                            setSelectedQueueId(queueId)
                            populateQueueProperties(queueId)
                        }
                        if (message) {
                            const newMessage = replaceVariables(message, questionnaireValues, formState, additionalOptions)
                            setSelectedMessage(newMessage)
                        }
                        if (userName) {
                            const newUserName = replaceVariables(userName, questionnaireValues, formState, additionalOptions)
                            setSelectedUsername(newUserName)
                        }

                        handleFindStep(target_success || '_next', {
                            message: replaceVariables(message || '', questionnaireValues, formState, additionalOptions),
                            queue_id: queueId,
                            userName: replaceVariables(userName || '', questionnaireValues, formState, additionalOptions),
                        })
                    } else {
                        handleFindStep(target_fail || '_next', {
                            message: replaceVariables(message || '', questionnaireValues, formState, additionalOptions),
                            queue_id: queueId,
                            userName: replaceVariables(userName || '', questionnaireValues, formState, additionalOptions),
                        })
                    }
                }, 0)

                return null
            }
            case 'redirect': {
                const {target} = step
                setTimeout(() => {
                    handleFindStep(target || '_next')
                }, 0)
                return null
            }
            default:
                return null
        }
    }

    // redirect to chat or close
    const handleComplete = (options?: {
        queue_id?: string, message?: string, userName?: string
    }) => {
        const queueId = options?.queue_id || selectedQueueId
        const message = options?.message || selectedMessage
        const userName = options?.userName || selectedUsername

        if (queueId) {
            let formStateToSend = {...formState}

            if (type === 'postAudienceQuestionnaire') {
                formStateToSend = Object.keys(formState).reduce((acc, key) => {
                    if (formState[key]?.questionnaireType === 'postAudienceQuestionnaire') {
                        acc[key] = formState[key]
                    }
                    return acc
                }, {} as Record<string, any>)
            }

            const metadataKey = type === 'postAudienceQuestionnaire' ? 'post_answers' : 'pre_answers'
            const {metadataToSend /* ,ratingToSend, */} = prepareMetadata(formStateToSend)

            onQuestionnaireComplete({
                fileIds: selectedFiles,
                message,
                metadata: {[metadataKey]: {...metadataToSend} as Record<string, string | boolean>},
                queueId,
                // rating: ratingToSend as any,
                userName,
            }).then(({queueClosed}) => {
                if (type === 'postAudienceQuestionnaire') {
                    findStep('_completed')
                } else if (type === 'preAudienceQuestionnaire') {
                    if (queueClosed) {
                        findStep('_queue_closed')
                    }
                }
            })
        } else {
            closeEmbed()
        }
    }

    const handleRegister = (options?: {
        queue_id?: string
    }) => {
        const queueId = options?.queue_id || selectedQueueId

        if (queueId) {
            if (onQuestionnaireRegister) {
                const formStateToSend = {...formState}
                const {metadataToSend} = prepareMetadata(formStateToSend)

                onQuestionnaireRegister({
                    fileIds: selectedFiles,
                    message: selectedMessage,
                    metadata: metadataToSend,
                    queueId,
                    userName: selectedUsername,
                }).then(() => {
                    findStep('_registered')
                })
            }
            setQreError(null)
        } else {
            setQreError({
                message: t('QueueId was not provided.'),
                title: t('Queue register error'),
            })
        }
    }

    const showNextStep = () => {
        if (currentStep === undefined) {
            return
        }

        const nextStep = questionnaire[currentStep + 1]
        if (nextStep) {
            if (nextStep.type === 'view') {
                setStepsHistory([...stepsHistory, currentStep + 1])
            }
            setCurrentStep(currentStep + 1)
        } else {
            setCurrentStep(undefined)
            handleComplete()
        }
    }

    const showPrevStep = () => {
        if (embed?.lightBot) {
            const history = [...stepsHistory]
            const prevStepIndex = history[history.length - 2]
            const prevStep = questionnaire[prevStepIndex]

            if (prevStep) {
                setCurrentStep(prevStepIndex)
                if (prevStep.type === 'view' && currentStep !== undefined) {
                    setStepsHistory([...stepsHistory, prevStepIndex])
                }
            } else {
                setCurrentStep(0)
                setStepsHistory([0])
            }
        } else {
            const history = [...stepsHistory]

            if (!embed?.lightBot) {
                history.pop()
            }
            const prevStepIndex = history[history.length - 1]
            const prevStep = questionnaire[prevStepIndex]
            if (prevStep) {
                setCurrentStep(prevStepIndex)
                if (prevStep.type === 'view') {
                    setStepsHistory(history)
                }
            } else {
                setCurrentStep(0)
                setStepsHistory([0])
            }
        }
    }

    const findStep = (target: string) => {
        const stepIndex = questionnaire.findIndex((st: NinchatEnvironmentConfig['preAudienceQuestionnaire'][0]) => st.id === target)
        if (questionnaire[stepIndex]) {
            setCurrentStep(stepIndex)
            if (questionnaire[stepIndex].type === 'view') {
                setStepsHistory([...stepsHistory, stepIndex])
            }
        } else if (target === '_completed') {
            setCurrentStep(undefined)
            closeEmbed()
        } else if (target === '_registered') {
            setCurrentStep(undefined)
            closeEmbed()
        } else if (target === '_queue_closed') {
            // if there is no _queue_closed step defined, we show error message
            setCurrentStep(undefined)

            setQreError({
                message: t('Queue has closed during your time in the pre-audience questionnaire.'),
                title: t('Queue has closed'),
            })
        } else {
            setCurrentStep(undefined)
            handleComplete()
        }
    }

    const handleQuestionnaireQueueButtonClick = (queue_id: string, target: string) => {
        setButtonInteraction(true)
        setSelectedQueueId(queue_id)
        populateQueueProperties(queue_id)
        handleFindStep(target, {queue_id})
    }

    const handleFindStep = (target: string, options?: {
        message?: string
        userName?: string
        queue_id?: string
    }) => {
        const queue_id = options?.queue_id
        const message = options?.message
        const userName = options?.userName

        if (target === '_next') {
            // predefined next target
            showNextStep()
        } else if (target === '_back') {
            // predefined prev target
            showPrevStep()
        } else if (target === '_complete') {
            // predefined end target
            setCurrentStep(undefined)
            handleComplete({
                message,
                queue_id,
                userName,
            })
        } else if (target === '_register') {
            setCurrentStep(undefined)
            // predefined register target
            handleRegister({queue_id})
        } else if (target === '_close') {
            // predefined close target
            setCurrentStep(undefined)
            closeEmbed()
        } else if (target === '_cancel') {
            // predefined cancel target
            setCurrentStep(undefined)
            backToChat?.()
        } else if (target) {
            // handle custom target
            findStep(target)
        }
    }

    const populateQueueProperties = (queueId: string) => {
        const queue = audienceQueues.find((q) => q.queue_id === queueId)
        const queueClosed = !!queue?.queue_attrs?.closed
        const queueLength = queue?.queue_attrs?.length || 0
        const queueName = queue?.queue_attrs?.name || ''

        setSelectedQueueName(queueName)
        setSelectedQueueClosed(queueClosed)
        setSelectedQueueLength(queueLength)
    }

    const runQuestionnaire = () => {
        if (questionnaire.length <= 0) {
            handleComplete()
        }

        // eslint-disable-next-line no-negated-condition
        if (typeof defaultQuestionnaireState.currentStep !== 'undefined') {
            // load from state
            const {
                currentStep: step, selectedQueueId: queueId, stepsHistory: history, formState: state,
                selectedMessage: message, selectedUsername: username, stepsAnswersHistory: answersHistory,
            } = defaultQuestionnaireState

            if (queueId) {
                setSelectedQueueId(queueId)
                populateQueueProperties(queueId)
            }
            if (message) {
                setSelectedMessage(message)
            }
            if (username) {
                setSelectedUsername(username)
            }
            if (history) {
                setStepsHistory(history)
            }
            if (answersHistory) {
                setStepsAnswersHistory(answersHistory)
            }

            if (state) {
                const formStateTemp = Object.entries(state || {}).reduce((acc, [key, value]) => {
                    // load only uploaded files
                    if (value.type === 'attachment') {
                        // eslint-disable-next-line no-extra-parens
                        const files = (value?.value as Array<FileItem>).filter((v) => !!v.file_id)

                        acc[key] = {
                            ...value,
                            value: files,
                        }

                        const filesToAdd = files.reduce((ac, file) => {
                            if (file.file_id) {
                                ac.push(file.file_id)
                            }
                            return ac
                        }, [] as Array<NinchatProperties.FileID>)

                        setSelectedFiles([...filesToAdd])
                    } else {
                        acc[key] = value
                    }
                    return acc
                }, {} as FormState)

                setFormState({...formStateTemp})
            }

            setCurrentStep(step)
        } else {
            // some form state may be pushed from audienceMetadata
            const {formState: state} = defaultQuestionnaireState
            setFormState({...state})

            // show first step from list
            // eslint-disable-next-line prefer-destructuring
            const firstStep = questionnaire[0]
            if (firstStep) {
                setCurrentStep(0)
                setStepsHistory([0])
            } else {
                handleComplete()
            }
        }
    }

    useEffect(() => {
        stepInvalidFields.current = []
    }, [currentStep])

    useLayoutEffect(() => {
        if (buttonInteraction) {
            focusFirstElement(questionnaireWrapperRef?.current as HTMLElement)
        }
    }, [currentStep, buttonInteraction])

    useLayoutEffect(() => {
        // Scroll to bottom when content changes
        if (questionnaireInnerWrapperRef.current && embed?.lightBot) {
            questionnaireInnerWrapperRef.current.scrollTop = questionnaireInnerWrapperRef.current.scrollHeight
        }
    }, [currentStep, embed?.lightBot])


    useLayoutEffect(() => {
        if (validateStepRequiredFields) {
            // focus first ivalid field
            focusFirstElement(questionnaireWrapperRef?.current as HTMLElement,
                'input[aria-invalid="true"]:not([disabled]), ' +
                'textarea[aria-invalid="true"]:not([disabled]), ' +
                'select[aria-invalid="true"]:not([disabled])')
        }
    }, [validateStepRequiredFields, validateCounter])

    useEffect(() => {
        saveQuestionnaireState({
            buttonInteraction,
            currentStep,
            formState,
            selectedMessage,
            selectedQueueId,
            selectedUsername,
            stepsAnswersHistory,
            stepsHistory,
        })
    }, [selectedQueueId, selectedMessage, selectedUsername, currentStep, stepsHistory, formState, buttonInteraction, stepsAnswersHistory])

    useEffect(() => {
        if (audienceQueues.length > 0 && !questionnaireStarted && defaultQuestionnaireState) {
            runQuestionnaire()
            setQuestionnaireStarted(true)
        }
    }, [audienceQueues.length, questionnaireStarted, defaultQuestionnaireState])

    const renderQuestionnaireContent = () => {
        if (!questionnaireStarted) {
            return null
        }

        if (embed?.lightBot) {
            return (
                <QuestionnaireLightBot
                    currentStep={currentStep || 0}
                    parseQuestionnaireStep={parseQuestionnaireStep}
                    questionnaire={questionnaire}
                    stepsHistory={stepsHistory}
                />
            )
        }

        return questionnaireStarted && currentStep !== undefined ? parseQuestionnaireStep(questionnaire[currentStep]) : null
    }

    return (
        <StyledQuestionnaireWrapper {...embed?.lightBot ? {} : {key: currentStep}} ref={questionnaireWrapperRef}>
            {embed?.embedState?.error || embed?.embedState?.connectionError ? <EmbedHero resetEmbed={resetEmbed} type='questionnaire' /> : null}
            <StyledQuestionnaireInnerWrapper ref={questionnaireInnerWrapperRef}>
                {qreError
                    ? (
                        <StyledErrorPage>
                            <h1>{qreError.title}</h1>
                            <p>{qreError.message}</p>
                            <div>
                                <QuestionnaireButton
                                    inline
                                    onClick={handleRegister}
                                    text={t('Register contact')}
                                />
                            </div>
                            <div>
                                <QuestionnaireButton
                                    inline
                                    onClick={() => {
                                        setQreError(null)
                                        setCurrentStep(0)
                                        setStepsHistory([0])
                                        setFormState({})
                                    }}
                                    text={t('Start again')}
                                    variant='secondary'
                                />
                            </div>
                            <div>
                                <QuestionnaireButton
                                    inline
                                    onClick={() => {
                                        setQreError(null)
                                        closeEmbed()
                                    }}
                                    text={t('Close window')}
                                    variant='secondary'
                                />
                            </div>

                        </StyledErrorPage>
                    )
                    : renderQuestionnaireContent()}
            </StyledQuestionnaireInnerWrapper>
        </StyledQuestionnaireWrapper>
    )
}

EmbedQuestionnaire.defaultProps = {
    backToChat: undefined,
    onQuestionnaireRegister: () => Promise,
    type: 'preAudienceQuestionnaire',
}
